import React from 'react';
import { selectFile } from 'src/utils/selectFile';

type OnClickType = (files: File[]) => void;

export class FileSelectorState {

    private readonly onClickCallback: OnClickType;
    public readonly maxFileSize: number;
    public readonly allowedFileTypes: string[];

    constructor(onClickCallback: OnClickType, maxFileSize: number = 1024, allowedFileTypes: string[] = []) {
        this.onClickCallback = onClickCallback;
        this.maxFileSize = maxFileSize;
        this.allowedFileTypes = allowedFileTypes;
    }

    public handleClick = async (event: React.SyntheticEvent) => {
        this.preventDefaults(event);
        const files = await selectFile({acceptFileType: this.allowedFileTypes.join(',')});
        this.onClickCallback(Array.from(files));
    }

    public get maxFileSizeMb() {
        return (this.maxFileSize / 1024) / 1024;
    }

    private preventDefaults = (event: React.SyntheticEvent) => {
        event.preventDefault();
        event.stopPropagation();
    }

}
